module.exports=!require("./_fails")(function(){return 7!=Object.defineProperty({},"a",{"get":function(){return 7}}).a});